import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  event: null,
  token: '',
  sessionId: '',
  expired: false,
  restrictedFeature: '',
};

const companionSlice = createSlice({
  name: 'companion',
  initialState,
  reducers: {
    startCompanion: (_, { payload }) => ({ ...initialState, ...payload, expired: false }),
    showCompanionRestriction: (state, { payload }) => {
      state.restrictedFeature = payload;
    },
    exitCompanion: () => initialState,
    expireCompanion: () => ({ ...initialState, expired: true }),
  },
  extraReducers: builder => {
    builder.addCase('user/addAccess', (state, action) => (action.payload ? initialState : state));
    builder.addCase('user/resetUser', () => initialState);
  },
});

export const { startCompanion, exitCompanion, expireCompanion, showCompanionRestriction } =
  companionSlice.actions;
export default companionSlice.reducer;
